import { Flex, Icon, PopoverLegacy } from "@amzn/storm-ui";
import { close } from "@amzn/storm-ui-icons";
import { isUndefined } from "lodash";
import React from "react";
import styled from "styled-components";
import { useStore } from "zustand";

import { featureReminderStore } from "../../store/featureReminder";
import type { FeatureReminderType } from "../../types/featureReminder";

const FeatureReminderCloseIcon = styled(Icon)`
    cursor: pointer;
`;

const PopoverContainer = styled(Flex)`
    margin: 20px;
    width: 20vw;
`;

const FeatureReminderViewer: React.FunctionComponent<{
    featureReminderType?: FeatureReminderType;
}> = ({ featureReminderType }) => {
    switch (featureReminderType) {
        default:
            return <></>;
    }
};

export const FeatureReminder: React.FC = () => {
    const [featureReminderType, resetAndDismiss] = useStore(
        featureReminderStore,
        (state) => [state.featureReminderType, state.resetAndDismiss],
    );

    return (
        <PopoverLegacy
            data-testid="feature-reminder-popover"
            position="right"
            isOpen={!isUndefined(featureReminderType)}
            withBackdrop
            transitionDuration={150}
        >
            <PopoverContainer columnGap="xsmall">
                <FeatureReminderViewer
                    featureReminderType={featureReminderType}
                />
                <FeatureReminderCloseIcon
                    data-testid="feature-reminder-close-button"
                    size="small"
                    type={close}
                    onClick={() => void resetAndDismiss()}
                />
            </PopoverContainer>
        </PopoverLegacy>
    );
};
